import React, { useEffect, useRef, useState } from 'react';

/**
 * ScrollReveal - Utility component for scroll-triggered animations
 *
 * Usage:
 * <ScrollReveal>
 *   <YourComponent />
 * </ScrollReveal>
 *
 * Or with custom delay:
 * <ScrollReveal delay={0.2}>
 *   <YourComponent />
 * </ScrollReveal>
 */
const ScrollReveal = ({ children, delay = 0, threshold = 0.1, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Optionally unobserve after reveal
          // observer.unobserve(entry.target);
        }
      },
      {
        threshold: threshold,
        rootMargin: '0px 0px -50px 0px', // Trigger slightly before element is fully visible
      }
    );

    const currentElement = elementRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [threshold]);

  return (
    <div
      ref={elementRef}
      className={`reveal ${isVisible ? 'active' : ''} ${className}`}
      style={{
        transitionDelay: `${delay}s`,
      }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
